(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tab-box"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabBox = document.querySelector('.tab-box');
  const tabLinks = tabBox.querySelectorAll('.tab-link');
  const tabContents = tabBox.querySelectorAll('.tab-content');

  tabLinks.forEach(link => {
    link.addEventListener('click', () => {
      const target = link.getAttribute('data-tab');

      tabLinks.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      link.classList.add('active');
      tabBox.querySelector('#' + target).classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
